$shm_hitalama_map_widget_float_form2 $shm_hitalama_map_widget_float_form_custom
	page_content / <= Form_workspace $mol_view
		sub <= form_workspace_content /$mol_view
			<= Form
			<= Relation_panel* $mol_view
				sub / <= Relation_form* $shm_hitalama_map_widget_float_form2_relation_form
					host <= form_self
					page_index <= relation_page_index* 0
	form_self null
	relation_page_index* 0

$shm_hitalama_map_widget_float_form2_relation_form $shm_hitalama_map_widget_float_table_form
	host $shm_hitalama_map_widget_float_form2
	page_index 0
